/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a search results pagination
 * @export
 * @interface DeprecatedPagination
 */
export interface DeprecatedPagination {
    /**
     * The number of results per page. A page may have less results if there are less than a full page of results, only on the last page in the results
     * @type {number}
     * @memberof DeprecatedPagination
     */
    pageSize?: number;
    /**
     * The current page number. The first page is number zero (0), the second page is number one (1), and so on
     * @type {number}
     * @memberof DeprecatedPagination
     */
    currentPage?: number;
    /**
     * The selected sort code
     * @type {string}
     * @memberof DeprecatedPagination
     */
    sort?: string;
    /**
     * The total number of pages. This is the number of pages, each of pageSize, required to display the totalResults.
     * @type {number}
     * @memberof DeprecatedPagination
     */
    totalPages?: number;
    /**
     * The total number of matched results across all pages
     * @type {number}
     * @memberof DeprecatedPagination
     */
    totalResults?: number;
}

/**
 * Check if a given object implements the DeprecatedPagination interface.
 */
export function instanceOfDeprecatedPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeprecatedPaginationFromJSON(json: any): DeprecatedPagination {
    return DeprecatedPaginationFromJSONTyped(json, false);
}

export function DeprecatedPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeprecatedPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'currentPage': !exists(json, 'currentPage') ? undefined : json['currentPage'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'totalResults': !exists(json, 'totalResults') ? undefined : json['totalResults'],
    };
}

export function DeprecatedPaginationToJSON(value?: DeprecatedPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageSize': value.pageSize,
        'currentPage': value.currentPage,
        'sort': value.sort,
        'totalPages': value.totalPages,
        'totalResults': value.totalResults,
    };
}

